import(/* webpackMode: "eager", webpackExports: ["AbsoluteCenter"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/absolute-center/absolute-center.js");
;
import(/* webpackMode: "eager", webpackExports: ["AccordionContext","AccordionItem","AccordionItemBody","AccordionItemContent","AccordionItemContext","AccordionItemIndicator","AccordionItemTrigger","AccordionPropsProvider","AccordionRoot","AccordionRootProvider"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/accordion/accordion.js");
;
import(/* webpackMode: "eager", webpackExports: ["AlertContent","AlertDescription","AlertIndicator","AlertRoot","AlertPropsProvider","AlertTitle"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/alert/alert.js");
;
import(/* webpackMode: "eager", webpackExports: ["BlockquoteCaption","BlockquoteContent","BlockquoteIcon","BlockquotePropsProvider","BlockquoteRoot"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/blockquote/blockquote.js");
;
import(/* webpackMode: "eager", webpackExports: ["Box"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/box/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/button/button.js");
;
import(/* webpackMode: "eager", webpackExports: ["IconButton"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/button/icon-button.js");
;
import(/* webpackMode: "eager", webpackExports: ["CardBody","CardDescription","CardFooter","CardHeader","CardPropsProvider","CardRoot","CardTitle"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/card/card.js");
;
import(/* webpackMode: "eager", webpackExports: ["CarouselAutoplayIndicator","CarouselAutoplayTrigger","CarouselContext","CarouselControl","CarouselIndicator","CarouselIndicatorGroup","CarouselIndicators","CarouselItem","CarouselItemGroup","CarouselNextTrigger","CarouselPrevTrigger","CarouselProgressText","CarouselPropsProvider","CarouselRoot","CarouselRootProvider"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/carousel/carousel.js");
;
import(/* webpackMode: "eager", webpackExports: ["Center"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/center/center.js");
;
import(/* webpackMode: "eager", webpackExports: ["CodeBlockAdapterProvider"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/code-block/code-block-adapter-provider.js");
;
import(/* webpackMode: "eager", webpackExports: ["CodeBlockCode","CodeBlockCodeText","CodeBlockCollapseIndicator","CodeBlockCollapseText","CodeBlockCollapseTrigger","CodeBlockContent","CodeBlockContext","CodeBlockControl","CodeBlockCopyIndicator","CodeBlockCopyTrigger","CodeBlockFooter","CodeBlockHeader","CodeBlockOverlay","CodeBlockRoot","CodeBlockTitle"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/code-block/code-block.js");
;
import(/* webpackMode: "eager", webpackExports: ["Code"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/code/code.js");
;
import(/* webpackMode: "eager", webpackExports: ["DataListItem","DataListItemLabel","DataListItemValue","DataListPropsProvider","DataListRoot"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/data-list/data-list.js");
;
import(/* webpackMode: "eager", webpackExports: ["Em"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/em/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/react/dist/esm/components/float/float.js");
;
import(/* webpackMode: "eager", webpackExports: ["GridItem"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/grid/grid-item.js");
;
import(/* webpackMode: "eager", webpackExports: ["Heading"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/heading/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Icon"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/icon/icon.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/react/dist/esm/components/image/image.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/react/dist/esm/components/link/link-box.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/react/dist/esm/components/link/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["ListIndicator","ListItem","ListRoot","ListRootPropsProvider"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/list/list.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/react/dist/esm/components/separator/separator.js");
;
import(/* webpackMode: "eager", webpackExports: ["SimpleGrid"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/simple-grid/simple-grid.js");
;
import(/* webpackMode: "eager", webpackExports: ["HStack"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/stack/h-stack.js");
;
import(/* webpackMode: "eager", webpackExports: ["Stack"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/stack/stack.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/react/dist/esm/components/stack/v-stack.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/react/dist/esm/components/text/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/announcements/AnnouncementDialog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/AboutTheRegulationsIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/AboutTheWcaIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/AdminResultsIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/AllCompsIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/BookmarkIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/CloneIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/CompetitorsIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/CompNotStartedIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/CompRegoClosed_redIcon.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/icons/CompRegoCloseDateIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/CompRegoClosedIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/CompRegoFullButOpen_orangeIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/CompRegoFullButOpenIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/CompRegoNotFullOpen_greenIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/CompRegoNotFullOpenIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/CompRegoNotOpenYet_greyIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/CompRegoNotOpenYetIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/CompRegoOpenDateIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/ContactIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/DelegateReportIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/DetailsIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/DeveloperExportIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/DisciplinaryLogIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/DisclaimerIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/DownloadIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/EditIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/EducationalResourcesIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/ErrorIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_222Icon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_333bfIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_333fmIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_333ftIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_333Icon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_333mbfIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_333mboIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_333ohIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_444bfIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_444Icon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_555bfIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_555Icon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_666Icon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_777Icon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_ClockIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_FtoIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_MagicIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_MinxIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_MmagicIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_PyramIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_SkewbIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/events/_Sq1Icon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/ExternalLinkIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/FacebookIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/FiltersIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/flags/_TwFlag.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/GithubIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/GuidelinesIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/HelpAndFaqsIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/IncidentsLogIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/InformationIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/InstagramIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/LanguageIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/ListIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/LocationIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/ManageTabsIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/MapIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/MediaSubmissionIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/MenuIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/MultimediaIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/MyCompsIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/MyResultsIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/NationalChampionshipIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/NewCompIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/OnTheSpotRegistrationIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/PaymentIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/PrivacyIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/RankingsIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/RecordsIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/RegionalOrganisationsIcon.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/icons/RegisterIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/RegistrationIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/RegulationsAndGuidelinesIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/RegulationsHistoryIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/RegulationsIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/ResultsExportIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/ScramblesIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/SearchIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/SpectatorsIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/SpeedcubingHistoryIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/SpotsLeftIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/StatisticsIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/TeamsCommitteesAndCouncilsIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/ToolsIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/TranslatorsIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/TwitchIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/UserIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/UsersPersonsIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/VenueIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/WcaDelegatesIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/WcaDocsIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/WcaLiveIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/WcaLogoIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/WcaOfficersAndBoardIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/WeiboIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/XIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icons/YoutubeIcon.tsx");
